import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';

interface IProps {
  disabled?: boolean;
  isLoading?: boolean;
  text?: string;
  onClick?: () => void;
}

export const VerFooter = ({ text = 'Continue', isLoading, disabled, onClick }: IProps) => {
  return (
    <div className='w-full p-[16px] md:p-[24px] z-40 bg-surface-primary-bw-00 sm:block shrink-0 border-t border-outline-primary-bw-03'>
      <div className={'w-full flex items-center justify-center mx-auto'}>
        <div className={'w-full max-w-[372px]'}>
          <LiliButton
            onClick={onClick}
            isLoading={isLoading}
            disabled={disabled}
            id={'business-verification-center__btn'}
            type={LiliButtonType.PRIMARY}
            title={text}
          />
        </div>
      </div>
    </div>
  );
};
